// src/locales/en/courierInvoice.js
export const courierInvoice = {
  // Page Titles
  uploadInvoice: "Upload Courier Invoice",
  allInvoices: "Courier Invoices",
  invoiceDetails: "Invoice Details",
  
  // Form Fields
  selectCourierAccount: "Select Courier Account",
  courierAccount: "Courier Account",
  invoiceNumber: "Invoice Number",
  invoiceDate: "Invoice Date",
  uploadFile: "Upload File",
  
  // File Upload
  dropFileHere: "Drop your file here or click to browse",
  supportsFiles: "Supports .xlsx, .xls, and .csv files",
  selectFile: "Select File",
  fileSelected: "File Selected",
  removeFile: "Remove File",
  
  // Column Mapping
  columnMapping: "Column Mapping",
  columnMappingLoaded: "Column mapping loaded",
  mappingWarnings: "Column Mapping Warnings",
  missingColumn: "Missing required column",
  downloadTemplate: "Download Template",
  
  // File Preview
  filePreview: "File Preview",
  firstRows: "First 5 Rows",
  
  // Eligible Orders
  eligibleOrders: "Eligible Orders",
  totalValue: "Total Value",
  
  // Processing
  startProcessing: "Start Processing",
  processing: "Processing",
  processingInvoice: "Processing Invoice",
  processingChunk: "Processing chunk",
  ordersProcessed: "orders processed",
  pauseUpload: "Pause",
  resumeUpload: "Resume",
  cancelUpload: "Cancel Upload",
  
  // Progress Stats
  matched: "Matched",
  notFound: "Not Found",
  alreadyInvoiced: "Already Invoiced",
  ineligible: "Ineligible",
  errors: "Errors",
  
  // Results
  processingComplete: "Processing Complete",
  totalOrders: "Total Orders",
  delivered: "Delivered",
  returned: "Returned",
  financialSummary: "Financial Summary",
  codCollected: "COD Collected",
  courierCharges: "Courier Charges",
  netAmountPayable: "Net Amount Payable",
  
  // Actions
  viewInvoiceDetails: "View Invoice Details",
  uploadAnotherInvoice: "Upload Another Invoice",
  downloadErrorReport: "Download Error Report",
  reprocessFailed: "Reprocess Failed",
  deleteInvoice: "Delete Invoice",
  
  // Messages
  invoiceUploadedSuccessfully: "Invoice processed successfully!",
  invoiceUploadCancelled: "Invoice upload cancelled",
  failedToLoadCouriers: "Failed to load courier accounts",
  failedToLoadMapping: "Failed to load column mapping for this courier",
  invalidFileType: "Please upload a valid Excel (.xlsx, .xls) or CSV file",
  fileMustHaveData: "File must contain at least a header row and one data row",
  failedToReadFile: "Failed to read file. Please ensure it is a valid Excel or CSV file.",
  selectCourierFirst: "Please select a courier account",
  enterInvoiceNumber: "Please enter an invoice number",
  selectInvoiceDate: "Please select an invoice date",
  uploadFileFirst: "Please upload a file",
  mappingWarningsConfirm: "There are column mapping warning(s). Do you want to continue anyway?",
  cancelUploadConfirm: "Are you sure you want to cancel this invoice upload? All progress will be lost.",
  failedToStartUpload: "Failed to start invoice upload",
  failedToUploadChunk: "Failed to upload chunk",
  failedToFinalizeInvoice: "Failed to finalize invoice",
  failedToCancelInvoice: "Failed to cancel invoice upload",
  
  // Invoice List
  searchByInvoice: "Search by invoice number",
  filterByStatus: "Filter by Status",
  filterByDate: "Filter by Date",
  invoiceNumberCol: "Invoice #",
  courierCompany: "Courier Company",
  invoiceDateCol: "Invoice Date",
  totalOrdersCol: "Total Orders",
  matchedOrdersCol: "Matched",
  statusCol: "Status",
  uploadedBy: "Uploaded By",
  uploadedOn: "Uploaded On",
  actions: "Actions",
  
  // Invoice Status
  pending: "Pending",
  processing: "Processing",
  completed: "Completed",
  failed: "Failed",
  partiallyProcessed: "Partially Processed",
  partially_processed: "Partially Processed",
  
  // Invoice Details
  invoiceInformation: "Invoice Information",
  ordersSummary: "Orders Summary",
  deliveryBreakdown: "Delivery Breakdown",
  matchStatusBreakdown: "Match Status Breakdown",
  discrepancies: "Discrepancies",
  invoiceOrders: "Invoice Orders",
  
  // Order Match Status
  matchStatus: "Match Status",
  orderMatched: "Matched",
  orderNotFound: "Not Found",
  orderAlreadyInvoiced: "Already Invoiced",
  orderIneligible: "Ineligible",
  
  // Delivery Status
  deliveryStatus: "Delivery Status",
  deliveryDelivered: "Delivered",
  deliveryReturned: "Returned",
  deliveryInTransit: "In Transit",
  deliveryOther: "Other",
  
  // Filters
  allStatuses: "All Statuses",
  allDeliveryStatuses: "All Delivery Statuses",
  allMatchStatuses: "All Match Statuses",
  applyFilters: "Apply Filters",
  resetFilters: "Reset Filters",
  
  // Empty States
  noInvoicesYet: "No invoices yet",
  uploadFirstInvoice: "Upload your first courier invoice",
  noOrdersFound: "No orders found",
  noDiscrepanciesFound: "No discrepancies found",
  
  // Validation
  invoiceNumberRequired: "Invoice number is required",
  courierAccountRequired: "Courier account is required",
  invoiceDateRequired: "Invoice date is required",
  fileRequired: "File is required",
  invalidInvoiceDate: "Invoice date cannot be in the future",
  
  // Error Details
  errorFound: "Error(s) Found",
  rowNumber: "Row #",
  airwaybillNumber: "Airwaybill #",
  errorMessage: "Error Message",
  
  // Statistics
  successRate: "Success Rate",
  totalInvoices: "Total Invoices",
  totalOrdersProcessed: "Total Orders Processed",
  totalValueProcessed: "Total Value Processed",
  
  // Reprocessing
  reprocessing: "Reprocessing",
  reprocessingComplete: "Reprocessing Complete",
  ordersReprocessed: "Orders Reprocessed",
  successfullyReprocessed: "Successfully Reprocessed",
  stillFailed: "Still Failed",
  
  // Confirmations
  deleteInvoiceConfirm: "Are you sure you want to delete this invoice? This action cannot be undone.",
  reprocessFailedConfirm: "Reprocess all failed orders for this invoice?",
  
  // Export
  exportInvoice: "Export Invoice",
  exportOrders: "Export Orders",
  exportDiscrepancies: "Export Discrepancies",

  // Details Page - Header
  backToInvoices: "Back to Invoices",
  invoiceTitle: "Invoice {{number}}",
  uploadedByUser: "Uploaded by {{user}}",
  downloadPDF: "Download PDF",
  reprocessFailedOrders: "Reprocess Failed Orders",
  cancel: "Cancel",
  delete: "Delete",
  
  // Details Page - Summary Cards
  matchedOrders: "Matched Orders",
  
  // Details Page - Tabs
  overview: "Overview",
  ordersTab: "Orders ({{count}})",
  discrepanciesTab: "Discrepancies ({{count}})",
  timeline: "Timeline",
  
  // Details Page - Overview Tab
  financialBreakdown: "Financial Breakdown",
  totalCodCollected: "Total COD Collected",
  totalCourierCharges: "Total Courier Charges",
  processingMetadata: "Processing Metadata",
  fileName: "File Name",
  fileSize: "File Size",
  rowsInFile: "Rows in File",
  processingTime: "Processing Time",
  seconds: "seconds",
  
  // Details Page - Orders Tab
  searchByAirwaybill: "Search by airwaybill number...",
  loadingOrders: "Loading orders...",
  noOrdersMatchFilters: "No orders match your current filters.",
  orderNumber: "Order Number",
  customerName: "Customer Name",
  shop: "Shop",
  codAmount: "COD Amount",
  courierCharge: "Courier Charge",
  amountPayable: "Amount Payable",
  viewDetails: "View Details",
  showingOrders: "Showing {{from}} to {{to}} of {{total}} orders",
  orderStatus: "Order Status",
  items: "Items",
  createdDate: "Created At",
  createdBy: "Created By",
  confirmedBy: "Confirmed By",

  
  // Details Page - Discrepancies Tab
  problemOrdersRequiringAttention: "Problem Orders Requiring Attention",
  downloadReport: "Download Report",
  allOrdersMatched: "All orders have been successfully matched and processed.",
  notFoundInSystem: "Not Found in System ({{count}})",
  reprocessAll: "Reprocess All",
  airwaybill: "Airwaybill",
  error: "Error",
  alreadyInvoicedGroup: "Already Invoiced ({{count}})",
  order: "Order",
  ineligibleOrdersGroup: "Ineligible Orders ({{count}})",
  
  // Details Page - Timeline Tab
  invoiceCreated: "Invoice Created",
  invoiceInitializedBy: "Invoice initialized by {{user}}",
  invoiceNumberLabel: "Invoice Number",
  expectedOrders: "Expected Orders",
  processingStarted: "Processing Started",
  startedProcessingInvoice: "Started processing invoice orders",
  chunksUploaded: "Chunks Uploaded",
  chunksCount: "{{received}}/{{expected}} chunks",
  orderDataUploadedInBatches: "Order data uploaded in batches",
  processingCompleted: "Processing Completed",
  invoiceFinalizedWithStatus: "Invoice finalized with status: {{status}}",
  processingTimeDuration: "Processing Time: {{seconds}}s",
  lastUpdated: "Last Updated",
  mostRecentModification: "Most recent modification to this invoice",
  
  // Details Page - Order Modal
  orderDetails: "Order Details",
  invoiceData: "Invoice Data",
  systemOrderData: "System Order Data",
  customer: "Customer",
  grandTotal: "Grand Total",
  noMatchingOrderFound: "No matching order found in system",
  
  // Details Page - Confirmation Modal
  cancelButton: "Cancel",
  confirm: "Confirm",
  cancelInvoiceTitle: "Cancel Invoice",
  cancelInvoiceConfirm: "Are you sure you want to cancel this invoice? All order updates will be rolled back.",
  deleteInvoiceTitle: "Delete Invoice",
  
  // Details Page - Error Messages
  failedToLoadInvoice: "Failed to load invoice details",
  failedToLoadOrders: "Failed to load invoice orders",
  failedToLoadDiscrepancies: "Failed to load discrepancies",
  failedToReprocessOrders: "Failed to reprocess orders",
  actionFailed: "Action failed",
  invoiceNotFound: "Invoice not found",
  loadingInvoiceDetails: "Loading invoice details...",
  
  // Details Page - Success Messages
  ordersReprocessedSuccess: "Reprocessed {{count}} order(s) successfully",
  invoiceCancelledSuccess: "Invoice cancelled successfully",
  invoiceDeletedSuccess: "Invoice deleted successfully",

  // Create Page - Header
  uploadAndProcessInvoices: "Upload and process courier company invoices",
  
  // Create Page - Courier Selection
  courierAccountSelection: "Courier Account Selection",
  courierAccountLabel: "Courier Account *",
  
  // Create Page - Invoice Form
  invoiceNumberLabel: "Invoice Number *",
  invoiceDateLabel: "Invoice Date *",
  enterInvoiceNumberPlaceholder: "Enter invoice number",
  
  // Create Page - File Upload
  uploadInvoiceFile: "Upload Invoice File",
  ordersCount: "{{count}} orders",
  columnMappingWarnings: "Column Mapping Warnings ({{count}})",
  filePreviewTitle: "File Preview (First 5 Rows)",
  missingRequiredColumn: "Missing required column: \"{{column}}\" for field \"{{field}}\"",
  
  // Create Page - Progress
  processingChunkProgress: "Processing chunk {{current}} of {{total}}",
  ordersProcessedProgress: "{{processed}} / {{total}} orders processed",
  
  // Create Page - Results
  errorsFound: "{{count}} Error(s) Found",

  // List Page - Main
  manageAndTrackInvoices: "Manage and track all courier company invoices",
  
  // List Page - Filters
  allCouriers: "All Couriers",
  searchByInvoice: "Search by invoice number...",
  
  // List Page - Empty States
  noInvoicesFound: "No invoices found",
  noInvoicesFoundDescription: "No invoices match your current filters. Try adjusting your search criteria.",
  uploadFirstInvoiceDescription: "Upload your first courier invoice to get started with invoice management.",
  
  // List Page - Bulk Actions
  deleteSelected: "Delete Selected ({{count}})",
  confirmBulkDelete: "Are you sure you want to delete {{count}} invoice(s)?",
  bulkDeleteSuccess: "{{count}} invoice(s) deleted successfully",
  bulkDeleteFailed: "{{count}} invoice(s) could not be deleted",
  failedToBulkDelete: "Failed to delete invoices",
  
  // List Page - Actions
  cancelInvoice: "Cancel Invoice",
  failedToLoadInvoices: "Failed to load courier invoices",
  failedToCancel: "Failed to cancel invoice",
  failedToDelete: "Failed to delete invoice",
  
  // Modal - Titles & Actions
  cancelInvoiceTitle: "Cancel Invoice",
  deleteInvoiceTitle: "Delete Invoice",
  confirmCancel: "Cancel Invoice",
  confirmDelete: "Delete Invoice",
  cancelWarning: "This will rollback all order updates made by this invoice.",
  deleteWarning: "This action cannot be undone.",
  
  // Common
  amountPayable: "Amount Payable",

  // Flags
  flagsTab: "Flags ({{count}})",
  flaggedOrders: "Flagged Orders",
  filterUnresolved: "Unresolved",
  filterResolved: "Resolved",
  filterAll: "All",
  recheckFlags: "Re-check Flags",
  flagsRechecked: "Checked {{checked}} orders, {{flagged}} flagged",
  failedToRecheckFlags: "Failed to re-check flags",
  failedToLoadFlags: "Failed to load flags",
  noFlags: "No flagged orders",
  flagReason_cod_mismatch: "COD Mismatch",
  flagReason_weight_mismatch: "Weight Mismatch",
  flagReason_delivery_charge_mismatch: "Delivery Charge Mismatch",
  flagReason_return_charge_mismatch: "Return Charge Mismatch",
  flagReason_paid_amount_mismatch: "Paid Amount Mismatch",
  flagReason_check_error: "Check Error",
  allFlagReasons: "All Flag Reasons",
  weight: "Weight (kg)",
  searchByAirwaybillOrOrder: "Search by airwaybill or order number...",
  flagExpectedVsInvoice: "Expected {{expected}} / Invoice {{actual}}",
  resolve: "Resolve",
  resolveFlagTitle: "Resolve Flag - {{airwaybill}}",
  resolveNote: "Resolve Note",
  resolveNotePlaceholder: "Explain how this was resolved...",
  resolvedByOn: "Resolved by {{user}} on {{date}}",
  flagResolved: "Flag resolved successfully",
  failedToResolveFlag: "Failed to resolve flag",
  flagReasonsColumn: "Flag Reasons",
  resolveNoteColumn: "Resolve Note",
  resolvedByOnShort: "by {{user}} · {{date}}"
};